import { Box, BoxProps, ColorOptions, Loader, Spacer } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { ScrollView, StatusBar, ViewStyle } from 'react-native'
import Carousal from '../../comps/Carousal'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../data/store'
import { isMobile, isOsMobile } from '../../util/util'
import { ActivateAccount } from './ActivateAccount'
import Highlights from './Highlights'
import RecentPayments from './Recents'
import RecentTransx from './Recents/index'

const Dashboard: FC = () => {
  const navigation = useNavigation()

  const {
    getVideos,
    getVideoList,
    toViewHighlights,
    isRecentTransactionTabEnabled,
    isRecentSettlementTabEnabled,
    isRecentRefundReportTabEnabled,
  } = useStores((root) => ({
    getVideos: root.settings.metaData.getVideos,
    getVideoList: root.settings.metaData.getVideoList,
    toViewHighlights: root.userManagement.toViewHighlights,
    isRecentTransactionTabEnabled: root?.userManagement?.isRecentTransactionTabEnabled(),
    isRecentSettlementTabEnabled: root?.userManagement?.isRecentSettlementTabEnabled(),
    isRecentRefundReportTabEnabled: root?.userManagement?.isRecentRefundReportTabEnabled(),
  }))

  const [getVideo, { state }] = useLazyApiData(getVideos)
  const listData = getVideoList()
  const [statsLoader, updateStatsLoader] = useState(false)
  const [showRecents, setShowRecents] = useState(false)

  useEffect(() => {
    if (listData?.length === 0 && isOsMobile()) {
      getVideo()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isLargeScreen = useIsLargeScreen()

  const isSmallDevice = isMobile(isLargeScreen)
  const handleNavigation = (item: any) => {
    navigation.navigate('video', { url: item.videoUrl })
  }

  const toggleLoader = (val: boolean) => {
    updateStatsLoader(val)
  }

  useEffect(() => {
    if (!isSmallDevice) {
      setShowRecents(isRecentTransactionTabEnabled || isRecentRefundReportTabEnabled || isRecentSettlementTabEnabled)
    }
  }, [isRecentTransactionTabEnabled, isRecentRefundReportTabEnabled, isRecentSettlementTabEnabled, isSmallDevice])

  const canViewHighlightsData = toViewHighlights()

  return (
    <Box flex={1} overflowY={'auto'} nativeID="showListScrollBar">
      <ModBox show={!isSmallDevice} {...styles.container} ph={16}>
        <ActivateAccount accountStatus="" />
        <Highlights toggleLoader={toggleLoader} canViewHighlightsData={canViewHighlightsData} />
        <Spacer hide={!statsLoader} size={16} direction={'vertical'} />
        {statsLoader && <Loader color="BLUE" />}
        <Spacer size={16} direction={'vertical'} />
        {showRecents && <RecentPayments toggleLoader={toggleLoader} />}
      </ModBox>
      <ModBox show={isSmallDevice} flex={1}>
        <StatusBar backgroundColor={defaultColors.BLACK} barStyle="light-content" />
        <ModBox padding={20} show={state === 'pending' && isOsMobile()} bg={'BACKGROUND' as ColorOptions}>
          <Loader />
        </ModBox>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.contentContainerStyle}>
          <ModBox overflow={'auto'} show={isOsMobile()}>
            {listData?.length > 0 && <Carousal data={listData} isSnapEnabled onPress={handleNavigation} />}
          </ModBox>
          <RecentTransx />
        </ScrollView>
      </ModBox>
    </Box>
  )
}

export default Dashboard

const styles = {
  container: {
    flex: 1,
    overflow: 'auto',
  } as BoxProps,
  contentContainerStyle: {
    flexGrow: 1,
    padding: 2,
  } as ViewStyle,
}
